import { theme } from '@prophecy/theme';
import styled from 'styled-components';
export const ErrorTrace = styled.pre `
  background: ${theme.colors.error50};
  color: ${theme.colors.error500};
  padding: ${theme.spaces.x12};
  font-size: ${theme.fontSizes.x13};
  overflow: auto;
`;
